// Import Packages
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';

// Import Material UI
import { Button, Checkbox, Grid, Switch, Tab, TablePagination, Tooltip } from '@material-ui/core';
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';

// Import Icons
import automFlow from '../../../../assets/icons/configurationIcons/autom-flow.svg';
import actionFlow from '../../../../assets/icons/configurationIcons/action-flow.svg';
import selectDeleteIcon from '../../../../assets/icons/configurationIcons/trash-box.svg'
import customiseViewIcon from "../../../../assets/icons/configurationIcons/customise-view.svg";
import emptyPageIcon from "../../../../assets/icons/configurationIcons/empty-page.svg";
import linkFlowIcon from "../../../../assets/icons/configurationIcons/go-to-flow.svg";
import dragFlowIcon from "../../../../assets/icons/configurationIcons/drag-flow.svg";
import addFlowIcon from "../../../../assets/icons/configurationIcons/add-flow.svg";
import WebhookIcon from "../../../../assets/icons/triggerIcons/Webhook.svg";
import EmailIcon from "../../../../assets/icons/triggerIcons/Email.svg";
import AppIcon from "../../../../assets/icons/triggerIcons/App.svg";
import ApiIcon from "../../../../assets/icons/triggerIcons/API.svg";
import ScheduleIcon from "../../../../assets/icons/triggerIcons/Schedule.svg";
import StandardAutomIcon from "../../../../assets/icons/triggerIcons/Standard-Autom.svg";
import EditIcon from '../../../../assets/icons/headerIcons/edit-icon.svg';


// Import Pages
import AddNewAutom from "../addNewAutoms/AddNewAutom";
import AutomService from "../../../../services/AutomService/AutomService";
import Search from "../../../../components/Search/Search";
import CustomizeView from "../../../../components/DataTable/CustomizeView/CustomizeView";
import { alertState, rolePermission, licensePermission, personalizationState, atomSearchValue } from '../../../../recoil-store/recoil-state';
import DataTableLoader from '../../../../components/ContentLoader/DataTableLoader';
import NewAccordion from '../../../../components/Accordion/NewAccordion';
import { Link } from 'react-router-dom';
import { convertToDateFormat, getLocalItemsForPagination, setLocalItemsForPagination } from '../../../../helpers/helper';
import NewDeleteConfirm from '../../../../components/DataTable/NewDeleteConfirm';

// Import CSS
import './AutomsList.css';
import AutomGroupOptions from '../autom/group/AutomGroupOptions';
import Pagination from '../../../../components/Pagination/Pagination';

let deletedAutoms = [];
let setSelectedAutomRow;
const AutomList = ({ reCheck, botLimit, activeAutomLen, draggingFlow, setDraggingFlow, group, groups, refreshAutomGroups,
    setRefreshAutomGroups, handleEditGroup, handleDeleteGroup, handleOnDrop, tab, setRefreshAutoms, isFirstTime, movedAutomId }) => {
    const { t } = useTranslation();
    const [customColumn, setCustomColumn] = useState([])
    const [selectedFlows, setSelectedFlows] = useState({})
    const [selectedAutom, setSelectedAutom] = useState("")
    const [selectedAutomId, setSelectedAutomId] = useState("")
    const [dragAvailable, setDragAvailable] = useState(false)
    const [data, setData] = useState([]);
    const [searchValue, setSearchValue] = useRecoilState(atomSearchValue);
    const [searchData, setSearchData] = useState([])
    const [count, setCount] = useState(0)
    const [refresh, setRefresh] = useState(false);
    const [openFilters, setOpenFilters] = useState(false);
    const [openCustomizeView, setOpenCustomizeView] = useState(false);
    const [chooseBot, setChooseBot] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [loading, setLoading] = useState(false); // default true
    const [open, setOpen] = useState(false);
    const activeAutoms = useRef([]);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);
    const setAlert = useSetRecoilState(alertState);
    const permissions = useRecoilValue(rolePermission);
    const license = useRecoilValue(licensePermission);
    const [firstTimeRender, setFirstTimeRender] = useState(false);
    const personalization = useRecoilValue(personalizationState);
    const label = "CONTENT.AUTOMS-LIST."

    useEffect(() => {
        async function fetchData() {
            const response = await AutomService.getAutomNameList();
            if (response?.status) {
                if (Array.isArray(response?.data)) {
                    activeAutoms.current = response.data.filter(x => x.status === 1);
                    if (license?.data.no_of_rpa_bots < activeAutoms.current.length) {
                        setChooseBot(true);
                    }
                }
            }
        }
        const localItemsPerPage = getLocalItemsForPagination("automList")
        fetchData(0, localItemsPerPage ? localItemsPerPage : 10).then(r => r);
        setSelectedFlows({})
    }, [reCheck]);

    useEffect(() => {
        if (firstTimeRender) {
            const localItemsPerPage = getLocalItemsForPagination("automList")
            fetchData(0, localItemsPerPage ? localItemsPerPage : 10).then(r => r);
        }
        setSelectedFlows({})
    }, [refresh, group]);
    useEffect(() => {
        const localItemsPerPage = getLocalItemsForPagination("automList")
        fetchData(0, localItemsPerPage ? localItemsPerPage : 10, "").then(r => r);
        setFirstTimeRender(true)
    }, [isFirstTime]);
    useEffect(() => {
        if (movedAutomId) {
            setSelectedFlows((pre) => {
                const newSelectFlows = JSON.parse(JSON.stringify(pre))
                delete newSelectFlows[movedAutomId]
                return newSelectFlows
            })
        }
    }, [movedAutomId]);

    const fetchData = async (startIndex, itemsPerPage, searchText) => {
        setLocalItemsForPagination("automList", itemsPerPage)
        setLoading(true);
        const response = await AutomService.getAllAutoms(
            '', tab === "downloadedAutoms" ? 1 : 0, group?.id ? group.id : "", startIndex ? startIndex : 0, itemsPerPage ? itemsPerPage : 10,
            searchText !== undefined ? searchText : searchValue);
        if (response?.status) {
            setDataLoading(true);
            if (response?.status) {
                if (Array.isArray(response?.data)) {
                    setData(response.data);
                    setSearchData(response.data);
                    setCount(response.count);
                    activeAutoms.current = response.data.filter(x => x.status === 1);
                    if (license?.data.no_of_rpa_bots < activeAutoms.current.length) {
                        setChooseBot(true);
                    }
                } else {
                    setData([]);
                    setSearchData([])
                }
            }

        }
        setLoading(false);
    }

    const handleRowsDelete = useCallback(() => {
        if (permissions?.data.includes('CUSTOMAUTOMS_DELETE')) {
            setOpenDelete("multi");
        } else {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTH-PAGES.RESET-PAGE.HASH-IS-NOT-PROVIDED"),
                severity: 'error'
            }))
        }
    }, [searchData, permissions]);

    const handleRowDelete = useCallback((id) => {
        if (id) {
            setSelectedAutomId(id)
        }
        if (permissions?.data.includes('CUSTOMAUTOMS_DELETE')) {
            setOpenDelete("single");
        } else {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTH-PAGES.RESET-PAGE.HASH-IS-NOT-PROVIDED"),
                severity: 'error'
            }))
        }
    }, [searchData, permissions]);


    const handleCheckSelectAllButton = () => {
        let selectedAutoms = []
        const newSearchData = JSON.parse(JSON.stringify(searchData))
        if (typeof selectedFlows === "object") {
            selectedAutoms = Object.keys(selectedFlows)
        }
        if (searchData.length && selectedAutoms.length) {
            const filteredSelectedAutoms = newSearchData.filter((data) => selectedFlows[data.id])
            if (filteredSelectedAutoms.length === newSearchData.length) {
                return false
            }
            else if (!filteredSelectedAutoms.length) {
                return true
            }
            else if (filteredSelectedAutoms.length < newSearchData.length) {
                // Burda çizgili gösterim olucak
                return false
            }
        }
        else {
            return true
        }
    }
    const handleSelectAllAutoms = () => {
        let selectedAutoms = []
        const newSearchData = JSON.parse(JSON.stringify(searchData))
        if (typeof selectedFlows === "object") {
            selectedAutoms = Object.keys(selectedFlows)
        }
        if (searchData.length && selectedAutoms.length) {
            const selectedAutoms = newSearchData.filter((data) => selectedFlows[data.id])
            if (selectedAutoms.length) {
                // deselect all işlemi
                const idsToRemove = new Set(selectedAutoms.map(item => item.id));
                setSelectedFlows((pre) => {
                    // pre'yi klonlayarak yeni bir nesne oluşturuyoruz
                    const updatedFlows = { ...pre };

                    // idsToRemove'daki anahtarları updatedFlows'tan siliyoruz
                    Object.keys(updatedFlows).forEach(key => {
                        if (idsToRemove.has(key)) {
                            delete updatedFlows[key];
                        }
                    });

                    return updatedFlows; // Yeni nesneyi döndürüyoruz
                })
            }
            else {
                // select all işlemi
                setSelectedFlows((pre) => {
                    const idObject = newSearchData.reduce((acc, obj) => {
                        acc[obj.id] = true;
                        return acc;
                    }, {});
                    return { ...pre, ...idObject };
                })
            }
        }
        else if (!selectedAutoms.length) {
            // select all işlemi
            setSelectedFlows((pre) => {
                const idObject = newSearchData.reduce((acc, obj) => {
                    acc[obj.id] = true;
                    return acc;
                }, {});
                return { ...pre, ...idObject };
            })
        }
    }
    const handleCheckForSelect = () => {
        let selectedAutoms = []
        const newSearchData = JSON.parse(JSON.stringify(searchData))
        if (typeof selectedFlows === "object") {
            selectedAutoms = Object.keys(selectedFlows)
        }
        if (searchData.length && selectedAutoms.length) {
            const filteredSelectedAutoms = newSearchData.filter((data) => selectedFlows[data.id])
            if (filteredSelectedAutoms.length === newSearchData.length) {
                return true
            }
            else if (!filteredSelectedAutoms.length) {
                return false
            }
            else if (filteredSelectedAutoms.length < newSearchData.length) {
                // Burda çizgili gösterim olucak
                return "indeterminate"
            }
            return false
        }
        else {
            return false
        }
    }


    function handleOpen(open, setState) {
        setState(!open);
    }

    const deleteAutoms = async () => {
        const keys = selectedAutomId ? selectedAutomId : Object.keys(selectedFlows)
        let ids = keys;
        setLoadingDelete(true);
        const response = await AutomService.deleteAutoms(ids);
        if (response) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t(`MESSAGES.AUTOMS.${response.message}`),
                severity: response.status ? 'success' : 'error'
            }))
            if (response.status) {
                setSelectedFlows({});
                setSelectedAutomId("")
                setRefreshAutomGroups((pre) => !pre)
                setRefreshAutoms((pre) => !pre)
            }
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        }
        setLoadingDelete(false);
    };
    const handleStatusChange = async (e, id) => {
        const res = await AutomService.changeAutomsStatus({ status: e.target.checked, ids: [id] });
        if (res?.status) {
            setSearchData((preData) => {
                const newData = JSON.parse(JSON.stringify(preData))
                newData.map(element => {
                    if (element.id === id) {
                        element.status = !e.target.checked ? 1 : 0
                    }
                })
                return newData
            })
            setData((preData) => {
                const newData = JSON.parse(JSON.stringify(preData))
                newData.forEach(element => {
                    if (element.id === id) {
                        element.status = !e.target.checked ? 1 : 0
                    }
                })
                return newData
            })
        }
    }

    const handleEditAutom = async (autom) => {
        setSelectedAutom(autom)
        setOpen(true)
    }

    const handleClick = () => {
        setOpen(!open);
    };
    const handleSelectFlows = (value, id) => {
        setSelectedFlows((pre) => {
            if (value) {
                return { ...pre, [id]: true }
            }
            else {
                const newSelectFlows = JSON.parse(JSON.stringify(pre))
                delete newSelectFlows[id]
                return newSelectFlows
            }
        })
    };
    const handleDragStart = (e, id) => {
        setDraggingFlow(id)
    };
    const handleMouseEnter = (e) => {
        e.preventDefault()
        setDragAvailable(true)
    };
    const handleMouseLeave = (e) => {
        setTimeout(() => {
            setDragAvailable(false)
        }, [500])
    };
    const findTriggerType = (type) => {
        switch (type) {
            case "webhook":
                return WebhookIcon
            case "email":
                return EmailIcon
            case "app":
                return AppIcon
            case "api":
                return ApiIcon
            case "schedule":
                return ScheduleIcon
            default:
                return StandardAutomIcon
        }
    };

    useEffect(() => {
        const column = [
            {
                id: 0,
                name: "functions",
                label: "",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRenderLite: (dataIndex, data, drag) => {
                        if (searchData[dataIndex]) {
                            return (
                                <div className='flow-function-container flow-configure-container'>
                                    <img ref={drag} onClick={(e) => { e.preventDefault() }} onMouseLeave={(e) => handleMouseLeave(e)} onMouseEnter={(e) => handleMouseEnter(e)} draggable={false} onDragStart={(e) => handleDragStart(e, searchData[dataIndex].id)} className='flow-option-img' src={dragFlowIcon} />
                                    <Checkbox
                                        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                                        checked={selectedFlows[searchData[dataIndex].id] ? true : false}
                                        onClick={(e) => handleSelectFlows(e.target.checked, searchData[dataIndex].id)}
                                    />
                                </div>
                            );
                        }
                    },
                },
            },
            {
                id: 1,
                name: 'status',
                label: "",
                options: {
                    filter: false, sort: true,
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        if (searchData[dataIndex]) {
                            return (
                                <Switch
                                    checked={!!searchData[dataIndex]?.status}
                                    onChange={(e) => {
                                        handleStatusChange(e, searchData[dataIndex]?.id).then(r => r)
                                    }}
                                    color="primary"
                                />
                            );
                        }
                    }
                }
            },
            {
                id: 2,
                name: "image_path",
                label: "",
                options: {
                    filter: true, sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData[dataIndex]) {
                            return <div style={{ display: "flex", gap: "10px" }}>
                                <Tooltip title={searchData[dataIndex].type} placement="top">
                                    <div className={`autom-group-image ${searchData[dataIndex].type === "Action" ? "action-group-image" : ""}`} style={{ backgroundColor: `${searchData[dataIndex].type === "Autom" ? "#4F6E90" : "#F4BB66"} ` }}>
                                        {searchData[dataIndex].type === "Autom" ?
                                            <img draggable={false} style={{ width: "24px", height: "24px" }} src={automFlow} /> :
                                            <img draggable={false} style={{ width: "30px", height: "22px" }} src={actionFlow} />}
                                    </div>
                                </Tooltip >
                                {searchData[dataIndex].type !== "Action" ? <Tooltip title={t(`CONTENT.AUTOMS-LIST.TRIGGER-${searchData[dataIndex].trigger_type ? searchData[dataIndex].trigger_type?.toUpperCase() : "STANDARD"}`)} placement="top">
                                    <div className='autom-group-image' style={{
                                        backgroundColor: "rgb(255 255 255)", border: "1px solid #4F6E90"
                                    }}>
                                        <img draggable={false} style={{ width: "24px", height: `${!searchData[dataIndex].trigger_type ? "18px" : "24px"}` }} src={findTriggerType(searchData[dataIndex].trigger_type)} />
                                    </div>
                                </Tooltip > : ""}
                            </div >
                        }
                    },
                }
            },
            {
                id: 3,
                name: "name",
                label: t("CONTENT.AUTOMS-LIST.AUTOM-NAME"),
                options: {
                    filter: true,
                    sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData[dataIndex]) {
                            return (
                                <p className='bold-overflow-text info-text' style={{ maxHeight: "32px" }}>
                                    <Link
                                        style={{ color: "#4a4a4a", textDecoration: "none" }}
                                        data-test="autom-link"
                                        to={`/automs/${searchData[dataIndex]?.id}/autom/edit`}
                                    >
                                        {searchData[dataIndex].name}
                                    </Link>
                                </p>
                            );
                        }
                    },
                },
            },

            {
                id: 4,
                name: "group_name",
                label: t("CONTENT.AUTOMS-LIST.GROUP-NAME"),
                options: {
                    filter: true, sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData[dataIndex]) {
                            return <p className={`info-text ${searchData[dataIndex].group_name ? "group-text" : ""}`}
                                style={searchData[dataIndex].group_color && {
                                    backgroundColor: `rgba${searchData[dataIndex].group_color?.slice(4, -2)} 0.3)`,
                                    border: `1px solid ${searchData[dataIndex].group_color}`, color: `${searchData[dataIndex].group_color}`
                                }}>
                                {searchData[dataIndex].group_name ?
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "7px" }}>
                                        <div style={{
                                            border: `1px solid ${searchData[dataIndex].group_color}`, borderRadius: "10px", backgroundColor: `${searchData[dataIndex].group_color}`,
                                            width: "6px", height: "6px"
                                        }}></div>
                                        {searchData[dataIndex].group_name}
                                    </div>
                                    : "-"}
                            </p>
                        }
                    },
                }
            },
            {
                id: 5,
                name: "created_by_fullname",
                label: t("CONTENT.AUTOMS-LIST.CREATED-BY"),
                options: {
                    filter: true, sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData[dataIndex]) {
                            return <p className='info-text'>{searchData[dataIndex].created_by_fullname}</p>
                        }
                    },
                }
            },
            {
                id: 6,
                name: "created_at",
                label: t("CONTENT.AUTOMS-LIST.CREATED-AT"),
                options: {
                    filter: true, sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData[dataIndex]) {
                            return <p className='info-text'>{convertToDateFormat(searchData[dataIndex].created_at, personalization.date_format)}</p>
                        }
                    },
                }

            },
            {
                id: 7,
                name: "actions",
                label: "",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRenderLite: (dataIndex) => {
                        // Show edit icon if the status of the current autom is true and the user has less autom than specified in the license
                        if (searchData[dataIndex] && botLimit >= activeAutomLen) {
                            return (
                                <div className='flow-option-container flow-configure-container'>
                                    <div style={{ border: "1px solid #EEEEEE", height: "50px", margin: "0 25px 0 10px" }}></div>
                                    <Tooltip title={t(label + `OPEN-AUTOM`)} placement="top">
                                        <Link
                                            className='flow-option-img'
                                            data-test="autom-link"
                                            to={`/automs/${searchData[dataIndex]?.id}/autom/edit`}
                                        >
                                            <img className='flow-option-img' src={linkFlowIcon} />
                                        </Link>
                                    </Tooltip>
                                    <Tooltip title={t(label + 'EDIT')} placement="top">
                                        <img className='flow-option-img'
                                            onClick={() => handleEditAutom(searchData[dataIndex])}
                                            src={EditIcon} />
                                    </Tooltip>
                                    <Tooltip title={t(label + 'DELETE-AUTOM')} placement="top">
                                        <img onClick={() => handleRowDelete(searchData[dataIndex].id)}
                                            className='flow-option-img' src={selectDeleteIcon} />
                                    </Tooltip>
                                </div>
                            );
                        }
                    },
                },
            },
        ]
        setCustomColumn(column)
    }, [searchData, selectedFlows, t])

    const save = (newData) => {
        let i = searchData.findIndex(x => x.id === newData.id)
        if (i !== -1) {
            searchData[i].name = newData.name;
            searchData[i].description = newData.description;
            searchData[i].group_color = newData.group ? newData.group.color : null;
            searchData[i].group_name = newData.group ? newData.group.name : null;
        }
    }
    return (
        <div id="credential-container" className='data-container'>
            <div className='header-div'>
                {group?.name ?
                    <h3 className='header-title group-title'><span className='autom-group-header-title'>{t(label + "AUTOM-GROUP")}:  </span>
                        <div style={{ backgroundColor: `${group.color}` }} className='group-color-dot'></div> {group.name}
                        <AutomGroupOptions
                            options={{
                                edit: (e) => handleEditGroup(e, group),
                                delete: (e) => handleDeleteGroup(group, false),
                            }}
                        />
                    </h3>
                    : <h3 className='header-title'>{t(label + `${tab === "downloadedAutoms" ? "DOWNLOADED-AUTOMS" : "ALL-AUTOMS"}`)}</h3>}

                <Button onClick={handleClick} className="new-app-button"><img className='configure-key-icon' src={addFlowIcon} />{t("CONTENT.AUTOMS-LIST.CREATE-NEW-AUTOM")}</Button>
            </div>
            <Search data={data} xs={11} sm={11} md={11} lg={4} xl={4} spacing={2}
                searchKey={['name', 'description', 'type', 'updated_at', 'created_by_fullname', 'created_at']}>
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                    <Button className="searchbar-button application-searchbar-button"
                        onClick={() => handleOpen(openCustomizeView, setOpenCustomizeView)}>
                        <img className='configure-key-icon' src={customiseViewIcon} />{t('CONTENT.DATATABLE.TOOLBAR.CUSTOMIZE-VIEW')}</Button>
                    <Button disabled={!Object.values(selectedFlows).length} style={{ opacity: `${!Object.values(selectedFlows).length ? "0.5" : "1"} ` }}
                        className="searchbar-button application-searchbar-button"
                        onClick={() => handleRowsDelete()}>
                        <img className='configure-key-icon delete-key-icon' src={selectDeleteIcon} />{t('CONTENT.DATATABLE.TOOLBAR.DELETE')}</Button>
                </Grid>
            </Search>
            <div className='autom-list-select-deselect-all-button-container'>
                <div onClick={handleSelectAllAutoms}>
                    <Checkbox
                        className='autom-list-selected-autom-checkbox'
                        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                        indeterminateIcon={<IndeterminateCheckBoxIcon fontSize="small" />} // Çizgili gösterim için
                        indeterminate={handleCheckForSelect() === "indeterminate"} // Çizgili durumu
                        checked={handleCheckForSelect()}
                    />
                    {Object.keys(selectedFlows)?.length
                        ? <span className='autom-list-selected-autom-count'>
                            {`${Object.keys(selectedFlows).length}/${count} ${t('CONTENT.AUTOMS-LIST.SELECTED')}` + " "}
                        </span>
                        : ""}
                    <span className='autom-list-select-deselect-all-span'>
                        {handleCheckSelectAllButton()
                            ? t('CONTENT.AUTOMS-LIST.SELECT-ALL')
                            : t('CONTENT.AUTOMS-LIST.DESELECT-ALL')
                        }
                    </span>
                </div>
            </div>
            <div className='table-container automs-page'>
                {
                    loading ? <DataTableLoader /> : <>
                        {!searchData.length &&
                            <div className='empty-page-info-container'>
                                <img src={emptyPageIcon} />
                                <p className='info-text'>{t(label + 'EMPTY-FLOW')}</p>
                            </div>
                        }
                        {searchData && searchData.length ? searchData.map((data, index) => {
                            return <NewAccordion
                                data-test="automlist-datatable"
                                customColumns={customColumn}
                                selectableRows="multiple"
                                data={data ? data : []}
                                index={index}
                                title={t("CONTENT.AUTOMS-LIST.AUTOM-LIST")}
                                loading={loading}
                                loadingDelete={loadingDelete}
                                selectedRowMessage={label + "SELECTED-MESSAGE"}
                                perPageMessage={label + "PER-PAGE-MESSAGE"}
                                infoIcon={true}
                                selectedItems={selectedFlows}
                                setSelectedItems={setSelectedFlows}
                                gridColumns="0.3fr 0.4fr 0.58fr 1fr 1fr 1fr 1fr 1fr"
                                label={label}
                                draggingFlow={draggingFlow}
                                handleDragStart={handleDragStart}
                                visibility={draggingFlow && draggingFlow === data.id ? true : false}
                                dragAvailable={dragAvailable}
                            />
                        }) : ""}</>}
                {/* {searchData.length ?
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25, 100]}
                                component="div"
                                count={searchData.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            /> : ""} */}

                {openDelete &&
                    <NewDeleteConfirm
                        titleMessage={openDelete === "single"
                            ? t("CONTENT.AUTOMS-LIST.DELETE-AUTOM-WARNING-TITLE-SINGLE")
                            : Object.keys(selectedFlows)?.length > 1
                                ? t("CONTENT.AUTOMS-LIST.DELETE-AUTOM-WARNING-TITLE-MULTI")
                                : t("CONTENT.AUTOMS-LIST.DELETE-AUTOM-WARNING-TITLE-SINGLE")}
                        message={openDelete === "multi"
                            ? Object.keys(selectedFlows)?.length > 1
                                ? t("CONTENT.AUTOMS-LIST.DELETE-AUTOM-WARNING-COUNT-AUTOMS-DELETED", { count: Object.keys(selectedFlows)?.length })
                                : ""
                            : ""}
                        setOpenDelete={setOpenDelete}
                        deleteFunc={deleteAutoms} />}
            </div>
            {open && <AddNewAutom afterSave={save} automDetail={selectedAutom} setSelectedAutom={setSelectedAutom}
                groups={groups} selectedGroup={group} setOpen={setOpen} handleOnDrop={handleOnDrop} setRefresh={setRefresh} setRefreshAutomGroups={setRefreshAutomGroups} />}
            {openCustomizeView && <CustomizeView setOpen={setOpenCustomizeView} customColumn={customColumn}
                setCustomColumn={setCustomColumn} />}
            <Pagination
                totalItems={count}
                callFetch={fetchData}
                expand={true}
                reset={group}
                from={"automList"}
                trigger={refreshAutomGroups}
                displayNone={searchData.length ? false : true}
                stopFetch={!firstTimeRender}
                outItemsPerPage={() => getLocalItemsForPagination("automList")}
            />
        </div >
    );
};

export default AutomList;
